import { render, staticRenderFns } from "./BienPhotosGallery.vue?vue&type=template&id=e8688a48&"
import script from "./BienPhotosGallery.vue?vue&type=script&lang=js&"
export * from "./BienPhotosGallery.vue?vue&type=script&lang=js&"
import style0 from "./BienPhotosGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports